import { Notification } from "@drone-js/core";
import { VStack } from "apps/commons/components/Stack";
import { scrollToTop } from "apps/commons/functions/scrollToTop";
import { amenitiesBinder } from "libs/analytics/binders/onboarding/amenities";
import { useAnalytics } from "libs/analytics/useAnalytics";
import { type FunctionComponent, useEffect } from "react";
import { Title } from "../Title";
import { useStaticDataAtomValue } from "../staticDataAtom";
import { AmenityGroup } from "./AmenityGroup";
import { useAmenitiesHandler } from "./useAmenitiesHandler";

export const AmenitiesPage: FunctionComponent = () => {
    const {
        amenitiesGroups,
        cmsData: {
            amenity: {
                amenities,
                guestsFavorites,
                travelersPreferTheseAmenitiesWhenBookingAPlaceToStay,
                propertiesWithMoreAmenitiesTendToReceiveMoreViews,
            },
        },
    } = useStaticDataAtomValue();

    const { activeIds, handleToggleAmenity } = useAmenitiesHandler();
    const amenityGroupBaseProps = {
        activeIds,
        onClick: handleToggleAmenity,
    };

    useEffect(() => {
        scrollToTop();
    }, []);

    useAnalytics(amenitiesBinder);
    const amenityItems = amenitiesGroups.map((group) => group.amenities).flat();
    const favoriteAmenityGroupTypeId = 10;

    return (
        <VStack gap="24" pb="32">
            <Title title={amenities} />
            <AmenityGroup
                amenitiesGroupType={favoriteAmenityGroupTypeId}
                key={`amenity-group`}
                title={guestsFavorites}
                description={travelersPreferTheseAmenitiesWhenBookingAPlaceToStay}
                amenities={amenityItems}
                {...amenityGroupBaseProps}
            />
            <Notification
                intent="notice"
                title={propertiesWithMoreAmenitiesTendToReceiveMoreViews}
                asset={{
                    id: "fill.symbol.circle-info",
                }}
            />
        </VStack>
    );
};
